module.exports = __webpack_public_path__ + "static/logosquare240-81728c15dd90f000e434744c1cc0be40.png";